function scrubMobileOptimisationStyles(element) {
  if (element.classList.contains('hs-hd') && element.style.getPropertyValue('display') === 'none') {
    element.style.removeProperty('display');
  }
  element.classList.remove('hs-hd', 'hs-hm');
  return element;
}
export function mapFlexAreaModules(callbackfn) {
  const flexAreaRoot = document.getElementById('hs_cos_wrapper_main');
  if (!flexAreaRoot) {
    return;
  }
  const elements = Array.from(flexAreaRoot.getElementsByClassName('hs_cos_wrapper_type_module'));
  elements.forEach(element => {
    scrubMobileOptimisationStyles(element);
    callbackfn(element);
  });
}